import { Component } from '@angular/core';
import { DataSourceTestDriveTable } from '@components/new-table/data-sources/data-source-test-drive-table';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TestDriveService } from '@services/test-drive.service';
import { TestDriveTableSettings } from '@/table-settings/test-drive/test-drive-table-settings';
import { TestDriveModel } from '@/models/test-drive/test-drive.model';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';

@Component({
  selector: 'app-test-drive-page-list',
  templateUrl: './test-drive-page-list.component.html',
  styleUrls: ['./test-drive-page-list.component.scss'],
})
export class TestDrivePageListComponent {
  displayedColumns = TestDriveTableSettings.getColumnsSetting();
  dataSource = new DataSourceTestDriveTable(this.testDriveService);
  reloadTrigger$ = new Subject<any>();

  constructor(
    private testDriveService: TestDriveService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {}

  btnDetailsClickFunction({ id }: TestDriveModel) {
    this.router.navigate([`/test-drive/detail/${id}`]);
  }

  btnDeleteFunction({ id }: TestDriveModel) {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteTestDrive) => {
      if (deleteTestDrive) {
        this.testDriveService.deleteTestDrive(id).subscribe({
          next: () => {
            this.reloadTrigger$.next(1);
            this.toastr.success('Test Drive cancellato correttamente!');
          },
          error: (error) => {
            this.toastr.error(`Errore durante la cancellazione del test drive.`);

            LoggerService.error('deleteTestDrive failed!');
            LoggerService.error(error);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo test drive?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellato il test drive non sarà più possibile recuperarlo.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }

  newTestDrive() {
    this.router.navigate(['/test-drive/new']);
  }
}
